<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">废弃项目/合同申请表</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回详情</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="100px" class="form">

          <create-discard-approval ref="create" :project="project" :contract="contract" :userData="userData" :formByFather="form">
          </create-discard-approval>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments :projectId="form.projectId" :contractId="form.contractId" ref="attachments"
                :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom>

          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button :loading="formLoading" @click="createProject()" class="form-btn" type="success">确认提交通用审批申请表
              </el-button>
            </div>
          </el-form-item>

        </el-form>
      </el-col>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import Attachments from '@/components/Attachments'

  // import approvalUsers from '@/Mixins/approvalUsers'
  // import ApprovalItem from '@/components/ApprovalItem'
  import ApprovalItemByCustom from '@/components/ApprovalItemByCustom'

  import CreateDiscardApproval from '@/page/form/createDiscardApproval'
  export default {
    components: {
      ApprovalItemByCustom,
      CreateDiscardApproval,
      Attachments,
    },
    // mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        hasApplyId: '',
        contractType: 1,

        project: {},
        contract: {},
        form: {
          reason: "",
          depId: "",
          projectId: "",
          contractId: "",
        },
        // approvalUsersData: "",

        // 审批
        approvalType: "0",
        formLoading: false,

        applyInfo: '',
        attachmentArr: [],

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {},
    mounted() {
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
      }
      if (this.$route.query.projectId) {
        this.form.projectId = this.$route.query.projectId / 1
        this.getProject()
      }
      if (this.$route.query.contractId) {
        this.form.contractId = this.$route.query.contractId / 1
        this.getContract()
      }

      // this.approvalUsersData = this.approvalUsers['c100_' + this.form.type]
      this.getApplyData()
    },
    methods: {
      // 获取合同详情
      getContract() {
        ajax.get('/contract/info/' + this.form.contractId, '', (res) => {
          this.contract = res.vo
        })
      },
      // 获取项目详情
      getProject() {
        ajax.get('/gc/project/detail/' + this.form.projectId, '', (res) => {
          this.project = res.vo
        })
      },
      // 获取审批表原内容
      getApplyData() {
        this.hasApplyId = this.form.applyId ? true : false
        if (this.form.applyId) {
          this.formLoading = true
          this.getProjectApplyInfo()
        } else {
          // this.setSelectArr(this.applyInfo, 100, this.form.type / 1)
        }
      },
      // 获取原审批表内容
      getProjectApplyInfo() {
        ajax.get('/flow/discard/apply/info/' + this.form.applyId, '', (res) => {
          let _res = res.vo
          // this.form = res.vo
          this.form.projectId = _res.project.id
          this.form.reason = _res.reason
          this.form.depId = _res.department.id
          this.form.applyId = _res.flow.applyId

          this.attachmentArr = _res.attachments ? _res.attachments : []
          this.selectArr = _res.flow.approvals.map(item => item.user)
          this.formLoading = false
        })
      },
      // 提交申请
      createProject() {
        this.form = this.$refs.create.getFromData()

        if (!this.form.reason) {
          this.$message.error('废弃原因必须填写')
          return
        }

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        this.form.attachments = this.$refs.attachments.getAttachments()

        console.log(this.form.approvalUserIds)
        this.formLoading = true
        let _url = !this.form.applyId ? '/flow/discard/apply' : '/flow/discard/apply/edit'

        ajax.post(_url, this.form, (res) => {
          this.$message.success("提交审批成功，请耐心等待领导审批")
          this.$router.back()
          this.formLoading = false
        }, (res) => {
          this.formLoading = false
        })
      },
    },
    watch: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/createDiscard.vue